import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import { RefObject } from 'react';
import { CaseStudyDto } from '@/types/case-studies';
interface Props {
  wrapperRef: RefObject<HTMLDivElement | null>;
  displayedCases: CaseStudyDto[];
  hasNoResults: boolean;
  flipStateRef: RefObject<Flip.FlipState | null>;
  containerHeightRef: RefObject<number>;
  isTransitioningFromEmptyRef: RefObject<boolean>;
}
export const useGridFilteringAnimation = t0 => {
  const $ = _c(12);
  const {
    wrapperRef,
    displayedCases,
    hasNoResults,
    flipStateRef,
    containerHeightRef,
    isTransitioningFromEmptyRef
  } = t0;
  let t1;
  if ($[0] !== containerHeightRef || $[1] !== flipStateRef || $[2] !== hasNoResults || $[3] !== isTransitioningFromEmptyRef || $[4] !== wrapperRef) {
    t1 = () => {
      if (!wrapperRef.current) {
        return;
      }
      if (wrapperRef.current.style.opacity === "0") {
        gsap.to(wrapperRef.current, {
          opacity: 1,
          duration: 0.3
        });
      }
      if (hasNoResults) {
        const emptyResult = wrapperRef.current.querySelector(".empty-result");
        if (emptyResult) {
          gsap.fromTo(emptyResult, {
            opacity: 0,
            scale: 0.9
          }, {
            opacity: 1,
            scale: 1,
            duration: 0.4,
            ease: "power1.in",
            delay: 0.1
          });
        }
        containerHeightRef.current = wrapperRef.current.offsetHeight;
        return;
      }
      if (isTransitioningFromEmptyRef.current) {
        const oldHeight = containerHeightRef.current;
        const newHeight = wrapperRef.current.offsetHeight;
        gsap.set(".case-item", {
          opacity: 0,
          scale: 0.9
        });
        if (oldHeight && oldHeight !== newHeight) {
          gsap.fromTo(wrapperRef.current, {
            height: oldHeight
          }, {
            height: newHeight,
            duration: 0.4,
            ease: "power1.inOut",
            clearProps: "height"
          });
        }
        gsap.to(".case-item", {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          stagger: 0.05,
          ease: "power2.out",
          delay: 0.1
        });
        isTransitioningFromEmptyRef.current = false;
        containerHeightRef.current = 0;
        return;
      }
      if (flipStateRef.current) {
        const oldHeight_0 = containerHeightRef.current;
        const newHeight_0 = wrapperRef.current.offsetHeight;
        if (oldHeight_0 && oldHeight_0 !== newHeight_0) {
          gsap.fromTo(wrapperRef.current, {
            height: oldHeight_0
          }, {
            height: newHeight_0,
            duration: 0.4,
            ease: "power1.inOut",
            clearProps: "height"
          });
        }
        gsap.set(".case-item", {
          clearProps: "opacity,y,transform"
        });
        Flip.from(flipStateRef.current, {
          targets: ".case-item",
          duration: 0.4,
          ease: "power1.inOut",
          onEnter: _temp
        });
        flipStateRef.current = null;
        containerHeightRef.current = 0;
      }
    };
    $[0] = containerHeightRef;
    $[1] = flipStateRef;
    $[2] = hasNoResults;
    $[3] = isTransitioningFromEmptyRef;
    $[4] = wrapperRef;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== displayedCases || $[7] !== hasNoResults) {
    t2 = [displayedCases, hasNoResults];
    $[6] = displayedCases;
    $[7] = hasNoResults;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2 || $[10] !== wrapperRef) {
    t3 = {
      dependencies: t2,
      scope: wrapperRef
    };
    $[9] = t2;
    $[10] = wrapperRef;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  useGSAP(t1, t3);
};
function _temp(elements) {
  gsap.fromTo(elements, {
    opacity: 0,
    scale: 0.9
  }, {
    opacity: 1,
    scale: 1,
    duration: 0.4,
    delay: 0.1
  });
}